<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表
    -->
  <div class="user">

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_no" label="结算单号"></el-table-column>
          <el-table-column prop="platform_money" label="平台营业额"></el-table-column>
          <el-table-column prop="award_total_money" label="分红总金额"></el-table-column>
          <el-table-column prop="award_num" label="分红人数"></el-table-column>
          <el-table-column prop="start_time" label="结算周期">
              <template slot-scope="scope">
                  <div><span class="blue">{{ scope.row.start_time }}</span> - <span class="red">{{ scope.row.end_time }}</span> </div>
              </template>
          </el-table-column>

          <el-table-column prop="create_time" label="发放时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" >分红详情</el-button>
              <!-- <el-button @click="deleteClick(scope.row)" type="text" size="small" >删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Edit :open="open_edit" :id="id"  @close="closeEdit"></Edit>

  </div>
</template>

<script>
import PartnerApi from '@/api/partner.js';
import Edit from './dialog/Edit.vue';
export default {
  components: {
    Edit
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*角色是否加载完成*/
      role_loading:true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否打开编辑弹窗*/
      open_edit: false,
      id: 0,
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      PartnerApi.getMean(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.role_loading = false;
        })
        .catch(error => {});
    },

    /*打开编辑*/
    editClick(row) {
      this.id = row.id;
      this.open_edit=true;
    },

    /*关闭添加*/
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/partner/mean/index.vue